import logo from '../../assets/logo.png';
import './navbar.css';
import { GiHamburgerMenu } from 'react-icons/gi';
import { ImCross } from 'react-icons/im';

import BookAppointment from '../btn/BookAppointment';
import Menu from '../menu/Menu';

import { useState } from 'react';

const GuideNavbar = ({ clicked, isClicked, handleModal, modalRef }) => {
  const [activeLink, setActiveLink] = useState('');

  const handleClick = () => {
    isClicked(!clicked);
  };

  const SmoothScroll = (e) => {
    // e.preventDefault();
    // const target = e.target.getAttribute('href');
    // const element = document.querySelector(target);
    // element.scrollIntoView({
    //   behavior: 'smooth',
    //   block: 'start',
    // });
    // setActiveLink(target);
  };

  return (
    <>
      <nav className="Nav xl:px-[120px] md:px-[30px] sm:px-[30px] py-3">
        <li className="NavLogo" id="home">
          <a className="pt-4" href="/sale">
            <img
              src={logo}
              className=" w-full sm:w-[138px] sm:h-[40px] "
              alt=""
            />
          </a>
        </li>

        <ul className="NavbarWrapper">
          <li
            className={`NavElements ${
              activeLink === '#about' ? 'isActive' : ''
            }`}
          >
            <a href="#about" onClick={SmoothScroll}>
              About
            </a>
          </li>
          <li
            className={`NavElements ${
              activeLink === '#why-us' ? 'isActive' : ''
            }`}
          >
            <a href="#why-us" onClick={SmoothScroll}>
              Why Us
            </a>
          </li>
          <li
            className={`NavElements ${
              activeLink === '#our-story' ? 'isActive' : ''
            }`}
          >
            <a href="#our-story" onClick={SmoothScroll}>
              Our Story
            </a>
          </li>

          <li
            className={`NavElements ${
              activeLink === '#get-onboard' ? 'isActive' : ''
            }`}
          >
            <a href="#get-onboard" onClick={SmoothScroll}>
              Get Onboard
            </a>
          </li>
        </ul>
        <div>
          {/* <BookAppointment name="Book Appointment" /> */}
        </div>
        <>
          {/* {!clicked ? (
            <GiHamburgerMenu className="NavHamburger" onClick={handleClick} />
          ) : (
            <ImCross className="NavHamburger" onClick={handleClick} />
          )} */}
        </>
      </nav>

      {clicked ? <Menu modalRef={modalRef} handleModal={handleModal} /> : null}
    </>
  );
};

export default GuideNavbar;
